import { render, staticRenderFns } from "./AllPackages.vue?vue&type=template&id=c45df232&"
import script from "./AllPackages.vue?vue&type=script&lang=js&"
export * from "./AllPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports